<template>
  <div class="ui-work-list-wrapper">
    <WorkItem
      v-for="(item, index) in worksList"
      :key="`home_works_list_${index}`"
      :workItem="item"
      :index="index"
      :showOrderNum="showOrderNum"
      @resfresPraise="resfresPraise"
    />
  </div>
</template>

<script>
import WorkItem from "../WorkItem"

export default {
  name: "uiWorkListWrapper",
  props: {
    worksList: {
      type: Array,
      default() {
        return []
      }
    },
    showOrderNum: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    resfresPraise(praiseOptions) {
      this.$emit("resfresPraise", praiseOptions)
    }
  },
  components: {
    WorkItem
  }
}
</script>

<style lang="scss" scoped>
.ui-work-list-wrapper {
  width: 100%;
  height: auto;
  padding: 0 0.3rem;
  box-sizing: border-box;
}
</style>
